import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import { API } from '../../config/api/index';
import { message } from 'antd';

const { getUsers, getUsersError, getUsersBegin, createUsers, createUsersBegin, createUsersError } = actions;

const fetchUsers = params => {
  return async dispatch => {
    try {
      const { page = 1, limit = 10 } = params || {};
      dispatch(getUsersBegin());
      const pagination = `page=${page}&limit=${limit}`;
      const filter = `?sortBy=createdAt:asc&${pagination}`;
      const response = await DataService.get(`${API.pos.users}/${filter}`);
      return dispatch(getUsers(response.data));
    } catch (err) {
      return dispatch(getUsersError(err?.message || 'Error al intentar obtener usuarios'));
    }
  };
};

const createUser = params => {
  return async dispatch => {
    try {
      dispatch(createUsersBegin());
      const userData = {
        email: params.email,
        password: params.password,
        name: params.name,
        role: params.role,
      };
      // Solo agregar sucursalAsignada si existe
      if (params.sucursalAsignada) {
        userData.sucursalAsignada = params.sucursalAsignada;
      }
      await DataService.post(`${API.pos.users}/`, userData);
      message.success('Usuario creado con éxito');
      dispatch(createUsers());
      dispatch(fetchUsers());
    } catch (err) {
      return dispatch(createUsersError(err?.message || 'Error al intentar crear el usuario'));
    }
  };
};

const updateUser = params => {
  return async dispatch => {
    try {
      dispatch(createUsersBegin());
      const updateData = {};

      if (params.name) updateData.name = params.name;
      if (params.email) updateData.email = params.email;
      if (params.role) updateData.role = params.role;
      if (params.sucursalAsignada !== undefined) {
        updateData.sucursalAsignada = params.sucursalAsignada || null;
      }

      await DataService.patch(`${API.pos.users}/${params.idToUpdate}`, updateData);
      message.success('Usuario actualizado con éxito');
      dispatch(createUsers());
      dispatch(fetchUsers());
    } catch (err) {
      return dispatch(createUsersError(err?.message || 'Error al intentar actualizar el usuario'));
    }
  };
};

const changePassword = params => {
  return async dispatch => {
    try {
      dispatch(createUsersBegin());
      await DataService.patch(`${API.pos.users}/${params.idToUpdate}`, {
        password: params.password,
      });
      message.success('Contraseña cambiada con éxito');
      dispatch(createUsers());
      dispatch(fetchUsers());
    } catch (err) {
      return dispatch(createUsersError(err?.message || 'Error al intentar cambiar la contraseña'));
    }
  };
};

export { fetchUsers, createUser, updateUser, changePassword };
